import gdprWhite from "../../../framework/frameworkCard/icons/gdprWhite.svg";
import nis2White from "../../../framework/frameworkCard/icons/nis2White.svg";
import ai from "../../../framework/frameworkCard/icons/ai.svg";
import iso27001 from "../../../framework/frameworkCard/icons/iso27001.svg";
import customFramework from "../../../framework/frameworkCard/icons/customFramework.svg";
import { PredefinedRiskArea } from "../riskAreas/RiskAreas.types";

export const customRiskAreaImage = customFramework;

const imageByPredefinedRiskArea: Record<PredefinedRiskArea, string> = {
    [PredefinedRiskArea.Gdpr]: gdprWhite,
    [PredefinedRiskArea.Nis2]: nis2White,
    [PredefinedRiskArea.AiAct]: ai,
    [PredefinedRiskArea.InformationSecurity]: iso27001,
};

export function getPredefinedRiskAreaImage(key: PredefinedRiskArea): string {
    return imageByPredefinedRiskArea[key];
}
